export default {
  // 設定頁面
  PickGameTitle: "挑人轉盤-遊戲設定",
  candidatesLabel: "候選項目設定",
  candidatesPlaceholder: "輸入候選項目，可用換行或逗號(,)分隔，按下Enter確認新增項目，最大候選數為20個，最多10個隨機呈現在轉盤",
  clearSettings: "清空設定",
  saveSettings: "儲存設定",
  candidateExists: "候選項目已存在",
  maxCandidates: "最多只能新增20位候選項目",
  unsubmittedWarning: "發現到輸入框尚有未按下Enter 的項目，請確認後再儲存!",

  // 遊戲頁面
  gameTitle: "挑人轉盤",
  spinWheel: "轉動轉盤",
  winner: "獲勝者",
  spinAgain: "再轉一次",
  backToSettings: "返回設定"
}